




























  import { ChampFormulaire } from '@/commun/components/champ-formulaire';
  import { Validable } from '@/commun/components/champ-formulaire/mixins/validable';
  import Vue from 'vue';

  export default Vue.extend({
    name: 'TextArea',
    components: {
      ChampFormulaire,
    },
    mixins: [Validable],
    inheritAttrs: false,
    props: {
      maximumCaracteres: {
        type: Number,
        default: Infinity,
      },
      value: {
        type: [String, Object],
        default: '',
      },
    },
    data() {
      return {
        innerValue: '',
        estInvalide: false,
      };
    },
    created() {
      this.innerValue = this.value;
    },
  });
